// client/src/features/quotations/lookupNoPriceReason.ts
//
// Why a price lookup (`lookupItemPrice`) came back with no price when a row WAS found, worded for
// the person. One owner for the Add Item form and the grid's Refresh price (B018): Refresh said
// "No price was found" for every refusal, so a row the magnifier lists but pricing refuses read as
// no row at all. Null when the lookup gives no reason; each caller keeps its own sentence for that.

export interface NoPriceLookup {
  unitMismatch?: boolean;
  packTextConflict?: boolean;
}

export const lookupNoPriceReason = (result: NoPriceLookup, uom: string): string | null => {
  if (result.packTextConflict) {
    // D69: the pack in the typed name contradicts the pack count on file.
    return (
      `The pack in this name does not match the pack count on file, so ${uom} could mean single items or whole packs. ` +
      'Check which is meant and type the price, or correct Units / Case in Master Catalogue.'
    );
  }
  if (result.unitMismatch) {
    // Found, but in another unit with no ratio on file (D51: never a guessed 1:1).
    return (
      `This item is priced in another unit and nothing on file says how many ${uom} that holds. ` +
      'Add Units / Case to it in Master Catalogue, or choose the unit it is sold in.'
    );
  }
  return null;
};
